import Modal from '@/components/Modal/';
import { noop } from '@/utils/util';
import Ajax from '@/utils/ajax';
import loadingImg from '@/assets/images/tiny.gif';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Immutable from 'immutable';
import classNames from 'classnames';
import i18n from 'react-intl-universal';
import styles from './EditorModal.scss';
import Button from '../../components/Button/Button';

export default class EditorLinkModal extends Component {
  static defaultProps = {
    onModalCancelClick: noop,
    onModalConfirmBtnClick: noop,
  }
  constructor(props) {
    super(props);
    this.state = {
      error: '',
      urlValue: this.props.urlValue || '',
      textValue: this.props.textValue || '',
    };
  }

  getLinkInfo = (url) => {
    const { onModalConfirmBtnClick, onModalCancelClick } = this.props;
    if (!/^https?:\/\//.test(url)) {
      url = `http://${url}`; // eslint-disable-line no-param-reassign
    }
    let error = '';
    if (this.gettingLinkInfo) { return; }
    this.gettingLinkInfo = true;
    error = i18n.get('modal.getting-linkinfo');
    this.setState({
      error,
    });
    Ajax.getLinkInfo(url).then((res) => {
      const resData = res.data || {};
      this.gettingLinkInfo = false;
      onModalConfirmBtnClick('linkModal', { url, text: resData.title });
    }).catch((err) => {
      error = i18n.get('modal.getting-linkinfo-fail');
      // 报错提示
      this.setState({
        error,
      });
      this.gettingLinkInfo = false;
    });
  }
  onRemoveLinkBtnClick = () => {
    const { onModalRemoveLinkBtnClick } = this.props;
    onModalRemoveLinkBtnClick();
  }
  onConfirmBtnClick = (e) => {
    const { onModalConfirmBtnClick, onModalCancelClick } = this.props;
    const url = (this.urlInput.value || '').trim();
    const text = (this.textInput.value || '').trim();
    if (!url) {
      const error = i18n.get('error.link-no-empty');
      // 报错提示
      this.setState({
        error,
      });
    } else if (!text) {
      this.getLinkInfo(url);
    } else {
      onModalConfirmBtnClick('linkModal', { url, text });
    }
  }
  render() {
    const { error, urlValue, textValue } = this.state;
    const { onModalCancelClick, hasSelectLink } = this.props;
    return (
      <Modal
        width={412}
        visible
        showFooter={false}
        showMask
        closable
        isMiddle
        onCancel={onModalCancelClick}
      >
        <div className={classNames(styles['kalamu-modal'], styles['kalamu-link-modal'])}>
          <h3>{i18n.get('modal.insertlink')}</h3>
          <div className={classNames(styles['modal-body'])}>
            <div className={styles['input-prepend']}>
              <span className={styles['add-on']}><i className="fa fa-link"/></span>
              <input
                autoFocus
                name="url"
                placeholder={i18n.get('modal.urldes')}
                type="text"
                defaultValue={urlValue}
                ref={(v) => { this.urlInput = v; }}
              />
            </div>
            <div className={styles['input-prepend']}>
              <span className={styles['add-on']}><i className="fa fa-font"/></span>
              <input
                name="text"
                placeholder={i18n.get('modal.linktxtdes')}
                type="text"
                defaultValue={textValue}
                ref={(v) => { this.textInput = v; }}
              />
            </div>
            <div className={styles['message-text']}>{error}</div>
            <div className={styles['btn-wrap']}>
              {
                hasSelectLink &&
                <Button className={styles['remove-link-btn']} onClick={this.onRemoveLinkBtnClick}>{i18n.get('modal.removeLink')}</Button>
              }
              <Button type={'primary'} className={styles['btn']} onClick={this.onConfirmBtnClick}>{i18n.get('modal.confirm')}</Button>
              <Button className={styles['btn']} onClick={onModalCancelClick}>{i18n.get('modal.cancel')}</Button>
            </div>
          </div>
        </div>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/EditorModal/EditorLinkModal.js